
<app-department-info *ngIf="isLoading" [isPageLoading]="isLoading"/>
<app-department-info *ngIf="!isLoading" [componentData]="componentData" [mainTabsIds]="mainTabsIds" [pageNodeId]="pageNodeId"/>